import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { NewTableEditorComponent, NewTableEditorUserViewOptions } from 'new-table-editor';
import { Observable, Subject, Subscription } from 'rxjs';
import { LogLevel, LogSearchComponent, STLog } from 'scaletech-core';
import { FilterParams, StarbaseComponentMessage, toggleObjInArray } from 'starbase-launcher';
import { IUserTokenModel, StarbaseLoginService } from 'starbase-login';
import { AppGlobalsService } from '../services/app-globals.service';
import { LogDataService } from '../services/log-data.service';
import { StarbaseComponentMessageService } from '../services/starbase-component-message.service';

@Component({
  selector: 'app-logs',
  templateUrl: './logs.component.html',
  styleUrls: ['./logs.component.css']
})
export class LogsComponent implements OnInit, OnDestroy {

  showExceptions = false;
  private currentUser: IUserTokenModel;
  viewOptsID = 'logs';
  logUserViewOptions = new NewTableEditorUserViewOptions(true);

  logFilterParams = new FilterParams<STLog>();

  logCols = STLog.LogColumns();

  currentLogLevelFiltersSet: string[] = [];

  darkMode = false;
  glassMode = false;

  private viewOptionsSubscription: Subscription;

  get logLevels(): Array<string> {
    const keys = Object.keys(LogLevel);
    return keys.slice(keys.length / 2);
  }

  logDataSearch$ = new Observable<FilterParams<STLog>>();

  @ViewChild('mainLogs') mainLogsTable: NewTableEditorComponent<any>;
  @ViewChild('logSearch', { static: true }) logSearch: LogSearchComponent;

  constructor(
    public sbCmpMsgSvc: StarbaseComponentMessageService,
    public appGlobals: AppGlobalsService,
    public logDataSvc: LogDataService,
    public loginSvc: StarbaseLoginService) {
      this.darkMode = this.appGlobals.getStoredDarkModeSetting();
      this.glassMode = this.appGlobals.getStoredGlassModeSetting();
    }

  ngOnInit() {
    this.logFilterParams.addToSorts('timeStamp'); // default sort by newest log first
    this.logFilterParams.sortAsc = false;
    this.currentUser = this.loginSvc.getUserModel();
    this.currentUser = this.loginSvc.getUserModel();
    if (!this.appGlobals.currentUser || this.appGlobals.currentUser !== this.currentUser.user) {
      this.appGlobals.currentUser = this.currentUser.user;
    }

    this.darkMode = this.appGlobals.getStoredDarkModeSetting();


    const viewOptions = this.appGlobals.getViewOptions(this.viewOptsID);
    if (viewOptions) {
      viewOptions.optionsChanged = new Subject();
      this.logUserViewOptions = viewOptions;
    }

    this.viewOptionsSubscription =  this.logUserViewOptions.optionsChanged.subscribe((opts) => {
      const temp = opts.optionsChanged;
      opts.optionsChanged = undefined;
      this.appGlobals.setViewOptions(opts, this.viewOptsID);
      opts.optionsChanged = temp;
    });
  }

  ngOnDestroy() {
    if (this.viewOptionsSubscription) {
      this.viewOptionsSubscription.unsubscribe();
    }
  }

  private checkAdmin(): boolean {
    return this.loginSvc.getUserModel().isAdmin();
  }
  toggleExceptions(): void {
    this.showExceptions = !this.showExceptions;
    if (this.showExceptions) {
      if (this.checkAdmin()) {
        this.logCols = STLog.LogColumns(false, true, true);
      } else {
        this.showExceptions = false;
      }
    } else {
      this.logCols = STLog.LogColumns(false, true);
    }
  }

  searchTyping(searchText: string) {
    if (searchText === '') { // reload all data
      this.logFilterParams.searchPhrase = '';
      this.logFilterParams.explicitSearchProperties = [];
      this.logFilterParams.collection = [];
      this.reloadLogTable();
    } else {
      this.logFilterParams.searchPhrase = searchText;
      this.logFilterParams.explicitSearchProperties = this.logSearch.getEnabledFilterExplicitProperties();
    }
  }
  quickSearchLogs(results: STLog[]) {
    try {
      this.logFilterParams.collection = results;
      this.reloadLogTable();
    } catch (e) {
      this.handleSearchError(e);
    }
  }
  handleSearchError(e?: Error | string): void {
    setTimeout(() =>
      this.sbCmpMsgSvc.handleStarbaseComponentMsg(
        StarbaseComponentMessage.messageForUser(
          'Log search error',
          'Something went wrong when applying the search.',
        true)), 1);
    console.error(e);
  }

  public reloadLogTable(): void {
    this.logFilterParams.page = 1;
    this.mainLogsTable.dataFilterParams = this.logFilterParams;
    this.mainLogsTable.loadData();
  }

  clearLogLevelFilters(): void {
    this.logFilterParams.replaceFilter('Level', '');
    this.currentLogLevelFiltersSet = [];
    this.reloadLogTable();
  }
  updateLogLevelFilters(ll: LogLevel): void {
    try {
      toggleObjInArray(this.currentLogLevelFiltersSet, ll);
      this.logFilterParams.replaceFilter('Level', ''); // erase the current filter first, to prevent duplicates
      for (const l of this.currentLogLevelFiltersSet) {
        this.logFilterParams.addToFilter('Level', l);
      }
    } catch {
      this.sbCmpMsgSvc.handleStarbaseComponentMsg(
        StarbaseComponentMessage.messageForUser(
          'Filter error',
          'Could not apply Log Level filter.', true));
    }
    this.reloadLogTable();
  }

}
